export default __webpack_public_path__ + "static/media/Allegro.570ac0ed.png";